var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M3.71673 11.3688C3.77935 11.3938 3.8357 11.4063 3.89831 11.4063H10.3287C10.5854 11.4063 10.7983 11.1938 10.7983 10.9375C10.7983 10.6813 10.5854 10.4688 10.3287 10.4688H5.03161L12.996 2.51877C13.1776 2.33752 13.1776 2.03752 12.996 1.85627C12.8144 1.67502 12.5139 1.67502 12.3323 1.85627L4.36791 9.80627V4.51877C4.36791 4.26252 4.15503 4.05002 3.89831 4.05002C3.6416 4.05002 3.42871 4.26252 3.42871 4.51877V10.9375C3.42871 11 3.44123 11.0563 3.46628 11.1188C3.51011 11.2313 3.60403 11.325 3.71673 11.3688Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M13.6031 13.2812H2.95886C2.70214 13.2812 2.48926 13.4938 2.48926 13.75C2.48926 14.0063 2.70214 14.2188 2.95886 14.2188H13.6031C13.8598 14.2188 14.0727 14.0063 14.0727 13.75C14.0727 13.4938 13.8598 13.2812 13.6031 13.2812Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }